import React from 'react';
import styled from 'styled-components';
import $ from "jquery";
import * as d3 from 'd3';
import {colorLookup,colorLookupSDG} from '../utils/colorHash';
const color = colorLookup;
const sdg_color = colorLookupSDG;
const mapboxgl = require('mapbox-gl');

const Wrapper = styled.div`
  top: 80px;
  position: relative;
  overflow-x: hidden;
  &::before{
    content: '(Mouseover the Tag to see breakdown)';
    color: white;
    font-size: 11px;
    left: 5%;
    position: absolute;
    z-index: 1;
  }
`
const LegendContainer = styled.div`

    position: relative;
    width: 90%;
    float: left;
    left: 5%;
    padding-top: 40px;
    padding-bottom: 10px;
    z-index: 1;
`

const LegendItem = styled.p`
  cursor: pointer;
  font-family: 'Roboto';
  position: relative;
  float: left;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  padding: 2px 5px;
  margin-left: 10px;
  border-radius: 3px;
  color: white;
  background: ${props => props.bg};
`

export default class LocationChart extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      mouseoveredKey: null
    }
    this.currentSelectedItem = props.currentSelectedItem;
    this.data = props.data;
    this.list = props.list;

    this.canvasOverlayRender = this.canvasOverlayRender.bind(this);
    this.generateLegend = this.generateLegend.bind(this);
    this.drawCall = this.drawCall.bind(this);
  }

  componentWillReceiveProps(nextProps){
    this.currentSelectedItem = nextProps.currentSelectedItem;
    this.data = nextProps.data;
    this.list = nextProps.list;

    this.canvasOverlayRender();
  }

  componentDidMount() {
    // mapboxgl.accessToken = 'pk.eyJ1IjoiamlhaGFvMDExMjEiLCJhIjoiY2prZDIxdjZuMDQ4aDNwb2VqZXRyZm9oZyJ9.8H2Qmp_dzUr_u_zuFEA0JQ';
    mapboxgl.accessToken = 'pk.eyJ1IjoiamlhaGFvMDExMjEiLCJhIjoiY2o5ZDVhdG44MXloMDJ3bnJwdHJuMDE3NSJ9.GbiGXf5osJa5HEjrfNmfwQ'
    this.map = new mapboxgl.Map({
      container: this.mapContainer,
      style: 'mapbox://styles/jiahao01121/cjkdeeaqw064y2tmenp1e67su',
      attributionControl: false,
      center: [14.601066357081663,41.04494198215397],
      zoom: 0.9,
      maxZoom: 3.5,
    })
    this.mapContainerWidth = $(this.mapContainer).width();
    this.mapContainerHeight = $(this.mapContainer).height();

    window.d3.select(this.map.getCanvasContainer())
      .append('canvas')
      .attr('width',this.mapContainerWidth)
      .attr('height',this.mapContainerHeight)
      .style('opacity',0.999)
      .attr('class','canvas_overlay')
      .canvas(true);

    this.canvas = document.querySelector('.canvas_overlay');
    this.ctx = this.canvas.getContext('2d');
    this.map.on('viewreset', () => this.canvasOverlayRender());
    this.map.on('move', () => this.canvasOverlayRender());

    this.canvasOverlayRender();
  }

  canvasOverlayRender(){

    const currentSelectedKeys = this.list[this.currentSelectedItem]['key'];
    const currentSelectedKey = currentSelectedKeys[0];
    const optionMap = this.list[this.currentSelectedItem]['optionMap'];
    const options = Object.keys(optionMap);


    this.ctx.clearRect(0, 0, this.mapContainerWidth, this.mapContainerHeight);
    this.data.forEach(d =>{
      const typeCheck = typeof d[currentSelectedKey];
      if(typeCheck === 'number' && options.includes(d[currentSelectedKey].toString())){
        this.drawCall(d,currentSelectedKey);
      }else if (typeCheck === 'string') {
        d[currentSelectedKey].split(',').forEach( i =>{
          if(i != "" && options.includes(i) ) this.drawCall(d,currentSelectedKey,+i);
        } );
      }
    })

  }

  drawCall(d,currentSelectedKey,value){

    if(this.state.mouseoveredKey){
      if(typeof d[currentSelectedKey] === 'number'){
        if(d[currentSelectedKey] != this.state.mouseoveredKey){
          return;
        }
      }else if (typeof d[currentSelectedKey] === 'string') {
        if(value != this.state.mouseoveredKey){
          return;
        }
      }
    }

    const coord = this.map.project(new mapboxgl.LngLat(d.LocationLongitude,d.LocationLatitude));
    let size = 2.5;
    this.ctx.beginPath();
    this.ctx.moveTo(coord.x + size , coord.y);
    this.ctx.arc(coord.x, coord.y, size, 0, Math.PI*2);
    if(this.list[this.currentSelectedItem]['SDGColor']){
      this.ctx.fillStyle = value ? sdg_color(value) : sdg_color(d[currentSelectedKey]);
    }else{
      this.ctx.fillStyle = value ? color(value) : color(d[currentSelectedKey]);
    }
    this.ctx.fill();
  }

  generateLegend(){

    if(!this.data || !this.list) return;

    const optionsLookup = this.list[this.currentSelectedItem]['optionMap'];
    const options = Object.keys(optionsLookup);
    const JSX = [];
    options.forEach((d,i) =>{
      JSX.push(<LegendItem
        onMouseOver={() => this.setState({'mouseoveredKey': d},() => this.canvasOverlayRender())}
        onMouseOut={() => this.setState({'mouseoveredKey': null},() => this.canvasOverlayRender())}
        bg={() =>{
          if(this.list[this.currentSelectedItem]['SDGColor']){
            return sdg_color(d);
          }
          return color(d);
        }}
        key= {i}
        >{optionsLookup[d]}</LegendItem>)
    })
    return JSX;
  }

  render(){
    const style = {
      position: 'relative',
      width: '90%',
      left: '5%',
      height: '500px',
    };
    return(
        <Wrapper>
          <LegendContainer>
            {this.generateLegend()}
          </LegendContainer>

          <div style={style} ref={el => this.mapContainer = el} />
        </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/LocationChart.js